import React from 'react'
import Layout from '../components/Layout'
import { useParams } from 'react-router-dom'
import { useGetBookQuery } from '../features/api/apiSlice'
import Form from '../components/Form'

export default function EditBook() {
  const { bookId } = useParams()
  const { data: book } = useGetBookQuery(bookId)

  return (
    <Layout>
      <main class="py-6 2xl:px-6">
        <div class="container">
          <div class="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
            <Form editMode book={book} />
          </div>
        </div>
      </main>
    </Layout>
  )
}
